import React from 'react'
import { AppCrudTable } from '@components'
import { Skeleton } from '@mui/material'
import {
    executionDateColumn,
    historyColumn,
    idColumn,
    sitesColumn,
    runtimeColumn,
    userNameColumn
} from './columns'
import { useTable, useManageBatchStatusMultiple } from "../@hooks";
import GlobalExecutionToolbarSelect from "./Toolbar";


export default function GlobalExecutionsBatchTable() {
    const { isLoading, tableBatchData } = useTable()

    useManageBatchStatusMultiple()

    if (isLoading) return <Skeleton variant="rectangular" height={500}/>

    return <AppCrudTable
            title="Batch Executions"
            toolbarProps={{ actions: false }}
            data={tableBatchData}
            columns={[idColumn(),userNameColumn(),...sitesColumn(),executionDateColumn(), runtimeColumn(), ...historyColumn(),]}
            options={{
                selectableRows: 'multiple',
                customToolbarSelect: (selectedData, setSelectedRows) => <GlobalExecutionToolbarSelect
                    selectedData={selectedData}
                    setSelectedRows={setSelectedRows}/>
            }}
            setHeaderCellProps={() => ({ sx: { fontWeight: 'bold' } })}
            setBodyCellProps={() => ({ sx: { width: 250 } })}
        />
}